import { render } from "./ShortcutDialog.vue?vue&type=template&id=0d1fbae2&scoped=true"
import script from "./ShortcutDialog.vue?vue&type=script&lang=js"
export * from "./ShortcutDialog.vue?vue&type=script&lang=js"

import "./ShortcutDialog.vue?vue&type=style&index=0&id=0d1fbae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1fbae2"]])

export default __exports__